@if (toast) {
  <button
    [ngClass]="{
      'bg-[#eafcee]': toast.type === ToastType.Success,
      'bg-[#fef4f5]': toast.type === ToastType.Error,
      'bg-[#e8f5fe]': toast.type === ToastType.Info,
      'bg-[#fff8db]': toast.type === ToastType.Warning,
    }"
    (click)="removeToast()"
    class="relative flex items-center justify-between w-full h-full px-4 py-3 rounded-md"
    [@fadeInOut]
  >
    <div *transloco="let t; scope: 'toastMessages'; read: 'toastMessages'">
      <div
        class="absolute rounded-full bottom-0 left-0 h-[4px] bg-transparent w-full"
      >
        <div
          class="h-full transition-all ease-linear bg-green-600 rounded-b-md"
          [ngClass]="{
            'bg-green-600': toast.type === ToastType.Success,
            'bg-red-600': toast.type === ToastType.Error,
            'bg-blue-600': toast.type === ToastType.Info,
            'bg-yellow-600': toast.type === ToastType.Warning,
          }"
          [style.width.%]="100 - toast.progress"
        ></div>
      </div>
      <div class="flex items-center gap-2">
        <ng-container [ngSwitch]="toast.type">
          <icon-component
            *ngSwitchCase="ToastType.Success"
            color="#16a34a"
            icon="check"
          ></icon-component>
          <icon-component
            *ngSwitchCase="ToastType.Error"
            color="#dc2626"
            icon="error"
          ></icon-component>
          <icon-component
            *ngSwitchCase="ToastType.Info"
            color="#2563eb"
            icon="info"
          ></icon-component>
          <icon-component
            *ngSwitchCase="ToastType.Warning"
            color="#ca8a04"
            icon="warning"
          ></icon-component>
        </ng-container>
        <span
          [ngClass]="{
            'text-green-600': toast.type === ToastType.Success,
            'text-red-600': toast.type === ToastType.Error,
            'text-blue-600': toast.type === ToastType.Info,
            'text-yellow-600': toast.type === ToastType.Warning,
          }"
          class="text-left text-md"
        >
          {{ t(toast.toastMessage, getToastInterpolationParams(toast)) }}
        </span>
      </div>
    </div>
  </button>
}
